import request from '@/utils/request'
//const baseURL = 'http://test.straighthair.php.nantang-tech.com' //测试
const baseURL = 'http://wms.php.nantang-tech.com' //正式



// 上传交接凭证
export const upload_delivery_tickets = data => {
    return request({
        url: '/api/delivery/upload_delivery_tickets',
        method: 'POST',
        data,
        baseURL
    })
}

// 获取交接凭证
export const get_delivery_attached = params => {
    return request({
        url: '/api/delivery/get_delivery_attached',
        method: 'GET',
        params,
        baseURL
    })
}